import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Button from "../../../../common/Button";
import { updateInterventionAssessment } from "../../../../../redux/modules/intervention/actions";
import { InterventionStepsEnum } from "../../../text/data";
import { useStepNavigation } from "./useStepNavigation";

const TargetsResults = ({ intervention, currentInterventionSteps, currentStep: activeStep }) => {
  const dispatch = useDispatch();
  const { interventionId } = useParams();
  const { nextStep, previousStep } = useStepNavigation(
    InterventionStepsEnum.TargetsResults,
    currentInterventionSteps,
    activeStep
  );

  // Navigation functions
  const onNext = async () => {
    try {
      await dispatch(
        updateInterventionAssessment(interventionId, {
          currentStep: nextStep,
        })
      );
    } catch (error) {
      console.error("Failed to update intervention step:", error);
    }
  };

  const onPrevious = async () => {
    try {
      await dispatch(
        updateInterventionAssessment(interventionId, {
          currentStep: previousStep,
        })
      );
    } catch (error) {
      console.error("Failed to update intervention step:", error);
    }
  };

  // Determine if buttons should be enabled
  const canGoNext = true; // Add your business logic here
  const canGoPrevious = true; // Can go back to step 1
  if (!intervention) {
    return (
      <div className="w-full h-full flex items-center justify-center bg-white">
        <div className="text-center">
          <div className="text-gray-400 text-xl font-medium mb-4">
            No Intervention Data
          </div>
          <div className="text-gray-500 text-base">
            Targets & Results information is not available.
          </div>
        </div>
      </div>
    );
  }

  const targetsAndResults = intervention.targetsAndResults || {};

  return (
    <>
      {false && (
        <div>
          <div className="w-full h-full bg-white p-6 overflow-auto">
            <div className="space-y-6">
              {/* Primary Target */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Primary Target
                </h3>
                <p className="text-gray-800">
                  {targetsAndResults.primaryTarget ||
                    "Resolve drug therapy problem"}
                </p>
              </div>

              {/* Secondary Targets */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Secondary Targets
                </h3>
                <p className="text-gray-800">
                  {targetsAndResults.secondaryTargets ||
                    "No secondary targets defined"}
                </p>
              </div>

              {/* Success Criteria */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Success Criteria
                </h3>
                <p className="text-gray-800">
                  {targetsAndResults.successCriteria ||
                    "No success criteria defined"}
                </p>
              </div>

              {/* Measurable Outcomes */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Measurable Outcomes
                </h3>
                <p className="text-gray-800">
                  {targetsAndResults.measurableOutcomes ||
                    "No measurable outcomes defined"}
                </p>
              </div>

              {/* Timeline */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Timeline
                </h3>
                <p className="text-gray-800">
                  {targetsAndResults.timeline || "No timeline defined"}
                </p>
              </div>

              {/* Progress Indicators */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Progress Indicators
                </h3>
                <p className="text-gray-800">
                  {targetsAndResults.progressIndicators ||
                    "No progress indicators defined"}
                </p>
              </div>

              {/* Risk Mitigation */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Risk Mitigation
                </h3>
                <p className="text-gray-800">
                  {targetsAndResults.riskMitigation ||
                    "No risk mitigation strategies defined"}
                </p>
              </div>

              {/* Quality Metrics */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Quality Metrics
                </h3>
                <p className="text-gray-800">
                  {targetsAndResults.qualityMetrics ||
                    "No quality metrics defined"}
                </p>
              </div>
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="flex items-center justify-between space-x-4">
            <div className="w-full">
              {/* Progress indicator could go here */}
            </div>
            <div className="flex items-center gap-3">
              <Button
                type="primary-outline"
                text="Back"
                className="w-[200px] max-h-[52px] !rounded-[30px]"
                onClick={onPrevious}
                disabled={!canGoPrevious}
              />
              <Button
                type="primary"
                text="Next"
                className="w-[200px] max-h-[52px] !rounded-[30px]"
                onClick={onNext}
                disabled={!canGoNext}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TargetsResults;
